import { render } from "./WorkspacePage.vue?vue&type=template&id=f7272bb2&scoped=true"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"

import "./WorkspacePage.vue?vue&type=style&index=0&id=f7272bb2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7272bb2"]])

export default __exports__